import {useDispatch,useSelector} from 'react-redux'

import {
	getAllFormsForClient,
	getAllCustomForms,
	selectAllCustomForms,
} from '../../state/customFormsSlice'

export const useCustomForms = ()=>{
	const dispatch = useDispatch()
	const {status,formList} = useSelector(state=>state.customForms)
	const forms = useSelector(selectAllCustomForms)
	if(status==='init') dispatch(getAllCustomForms())
	return {status,forms,map:formList.entities}
}

export const useClientCustomForms = (clientId)=>{
	const dispatch = useDispatch()
	const {status,formList,clientId:prevClientId} = useSelector(state=>state.customForms)
	const forms = useSelector(selectAllCustomForms)
	if(
		status==='init'
		||
		(parseInt(prevClientId)!==parseInt(clientId)&&status==='idle')
	) dispatch(getAllFormsForClient({
		client_id:clientId,
		new_client:0
	}))
	return {status,forms,map:formList.entities}
}

export const useMultiFormsModal = ()=>(
	useSelector(state=>state.customForms.multiFormsModal)
)
